import { ExclamationCircleOutlined } from '@ant-design/icons';
import { css, cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { Link } from 'react-router-dom';
import { ColorConstant, ScreenBreakpoint, Spacing, TextAlign } from 'src/styles';

import { MTypography } from '../MTypography/MTypography';
import { UnknownErrorMessage } from '../UnknownErrorMessage/UnknownErrorMessage';

const rowStyle = css`
  width: 75%;
  margin: 0 auto;

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    width: 80%;
  }
`;

interface UnknownErrorContentProps {
  name?: string;
  message?: string | string[];
  className?: string;
}

export const UnknownErrorContent = ({ name, message, className }: UnknownErrorContentProps = {}) => {
  return (
    <Row className={cx(rowStyle, className)}>
      <Col span={24} className={cx(Spacing.my32, TextAlign.center)}>
        <ExclamationCircleOutlined style={{ fontSize: 72, color: ColorConstant.RED7 }} />
      </Col>
      <Col span={24} className={Spacing.my16}>
        <UnknownErrorMessage name={name} message={message} variant='h5' weight='semibold' />
      </Col>
      <Col span={24} className={Spacing.my16}>
        <MTypography variant='h5' weight='semibold'>
          What you can do:
        </MTypography>
        <ul>
          <li className={Spacing.my8}>
            <MTypography variant='h5' weight='semibold' key='go-to'>
              Go to <Link to='/'>Home page</Link>
            </MTypography>
          </li>
        </ul>
      </Col>
    </Row>
  );
};
